// extracted by mini-css-extract-plugin
module.exports = {"container":"_3zdhGYGTZnG0pJbThpbu72","visible":"S3VwxYweQwMDgLfg17EBr","leftHalf":"_27163hLBDLOqxTKYszLl19","rightHalf":"_1D1V9ENO5gd7a29NAPghBG"};